import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConvexReactClient } from "convex/react";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import App from "./App";
import "./styles.css";

// Read the Convex deployment URL from build-time env. NEVER hardcode a
// *.convex.cloud URL (global Convex rule) — throw loudly if it is missing so a
// misconfigured Pages build fails fast instead of silently rendering nothing.
const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;
if (!convexUrl) {
  throw new Error(
    "VITE_CONVEX_URL is not set — set it in .env.local (local) or the " +
      "Cloudflare Pages build env (deploy). It is the deployment's " +
      "*.convex.cloud URL.",
  );
}

const convex = new ConvexReactClient(convexUrl);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConvexAuthProvider client={convex}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConvexAuthProvider>
  </React.StrictMode>,
);
